import React from 'react'
import { Link, } from 'react-router-dom'
import { formatAddressUrlString, } from '../../util/formatters'
import PropTypes from 'prop-types'

const MarkerInfoWindow = ({
  activateProgram = null,
  address = '',
  description = '',
  name = '',
  progOccId = null,
  programType = '',
  title = '',
  type = '',
  viewUrl = null,
}) => {
  let typeToCheck, typeText
  if (type) {
    typeToCheck = type.toLowerCase()
  }
  switch (typeToCheck){
  case 'worksite':
    typeText = 'Worksite'
    break
  case 'partner':
    typeText = 'Partner'
    break
  case 'educational institution':
  case 'institution':
    typeText = 'Institution'
    break
  case 'session':
    typeText = 'Session'
    break
  case 'class site':
    typeText = 'Class Site'
    break
  case 'program contact':
  case 'contact':
  case 'how to apply contact':
    typeText = 'Contact'
    break
  default:
    typeText = ''
  }

  return (
    <div style={{ wordWrap: 'normal', }}>
      <p className={'heading-6 gmap-iw-title mt-1'}>
        <span className={'category-selected txt-wsac-secondary-2'}>{title}</span><br/>
        {description}
      </p>
      <span className={'heading-6 txt-wsac-secondary-2 category-selected gmap-iw-title'}>
        <b>{ name ? name : null }</b>
      </span>
      { typeText && <div className={'heading-6 gmap-iw-italic'}><b>{typeText}</b></div> }
      <p className={'body-text'}>
        { address && <><span className={'heading-6'}>{address}</span></> }
      </p>
      { viewUrl && <Link className={'float-right btn-sm-secondary btn btn-secondary mb-1 mr-1'} onClick={() => activateProgram(progOccId, programType)} to={viewUrl}>View</Link> }
      { address && <a label={'getdirections'} aria-label={'Get Directions'} className={'float-right btn btn-inverted border-0 mr-2 mb-1'} target={'_blank'} rel={'noopener noreferrer'} href={`https://www.google.com/maps/search/?api=1&query=${formatAddressUrlString(address)}`}>
        <i title={'View on Google Maps (opens a new tab)'} className={'fa fa-map-marked'} />
      </a>}
    </div>
  )
}

MarkerInfoWindow.propTypes = {
  activateProgram : PropTypes.func,
  address         : PropTypes.string,
  description     : PropTypes.string,
  name            : PropTypes.string,
  progOccId       : PropTypes.number,
  programType     : PropTypes.string,
  title           : PropTypes.string,
  type            : PropTypes.string,
  viewUrl         : PropTypes.string,
}

export default React.memo(MarkerInfoWindow)